import { API_BASE_URL } from 'lib/config/apiEndpoints';

export interface BloodVisionFreeRequestParams {
  email: string;
  country: string;
  source_url?: 'pricing' | 'waitlist';
  pincode?: string;
  plan_id?: number;
  affiliate_code?: string;
  utm_params?: Record<string, string>;
}

export interface BloodVisionFreeRequestResponse {
  status: 'ok' | 'error';
  data?: {
    success: boolean;
    // campaign_status?: string;
    campaign_status?: 'waitlist' | 'live' | 'expired';
  };
  error?: {
    message: string;
    code: number;
  };
}

export const submitBloodVisionFreeRequest = async (
  params: BloodVisionFreeRequestParams
): Promise<BloodVisionFreeRequestResponse> => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/web_v1/blood_vision_free_request`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    });

    const data = await response.json();

    if (!response.ok) {
      return {
        status: 'error',
        error: data.error || {
          message: 'Something went wrong',
          code: response.status,
        },
      };
    }

    return data;
  } catch (error) {
    return {
      status: 'error',
      error: {
        message: 'Network error. Please try again.',
        code: 500,
      },
    };
  }
};
